module.exports = __webpack_public_path__ + "static/media/7.28b43b5a.png";